import { useState } from "react";
import styled from "styled-components"
import CancelIcon from '@mui/icons-material/Cancel';
import BaseInput from "../../atoms/BaseInput";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';

const Container = styled.div`
  position: relative;
  width: 100%;
  min-height: 50px;
`;
const StyledBaseInput = styled(BaseInput)`
  padding-right: ${({ $hasValue }) => ($hasValue ? "72px" : "8px")};
  ${({ $error, theme }) => $error && `
    border-color: ${theme.colors.status.error} ;
  `}
`
const ButtonWrapper = styled.div`
  position: absolute;
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
  display: flex;
  gap: 8px;
`
const IconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 50px;
`;
const ClearIcon = styled(CancelIcon)`
  color: ${(props) => props.theme.colors.text.assistive};
`
const VisibilityOffIcon = styled(VisibilityOffOutlinedIcon)`
  color: ${(props) => props.theme.colors.text.assistive};
`
const VisibilityIcon = styled(VisibilityOutlinedIcon)`
  color: ${(props) => props.theme.colors.text.assistive};
`

const PasswordInput = ({placeholder, value, onChange, $error, ...props}) => {
  const [show, setShow] = useState(false)
  const handleClear = (e) => {
    e.preventDefault();
    onChange({ target: { value: "" } });
  };
  return (
    <Container>
      <StyledBaseInput
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        $hasValue={Boolean(value)}
        type={show? "text": "password"}
        $error={$error}
        {...props}/>
      <ButtonWrapper>
        {value && (
          <>
            <IconButton type="button" onClick={handleClear}>
              <ClearIcon />
            </IconButton>
            <IconButton
              type="button"
              aria-label={show ? "비밀번호 숨기기" : "비밀번호 보이기"}
              onClick={() => setShow((prev) => !prev)}>
              {show ? <VisibilityOffIcon /> : <VisibilityIcon />}
            </IconButton>
          </>
        )}
      </ButtonWrapper>
  
   
    </Container>
  )
}

export default PasswordInput
